import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class ValidationsService {

  url: string;

  constructor (private http: HttpClient) {
    this.url = environment.api.base_endpoint;
  }

  async searchProcess(id, curp) {
    // console.log('BEFORE BACKEND');
    try {
      const res = await this.http.get(`https://sftys.cdmx.gob.mx/api/v3/resultados/findOne?filter={"where":{"id_ldc":${id}, "llave.curp": "${curp}"}}`).toPromise();

      return res;
    } catch (err) {
      // console.log('err ', err);
      return err;
    }
  }

  async getCitizenProcesses(curp) {
    try {
      const res = await this.http.get(`${this.url}processes/citizen/${curp}`).toPromise();

      return res;
    } catch (err) {
      // console.log("err => ", err);

      return err;
    }
  }

  async getProcess(id) {
    // TODO change name of function not clear
    try {
      const res = await this.http.get(`https://sftys.cdmx.gob.mx/api/v1/processes/${id}`).toPromise();
      // const res = await this.http.get(`${this.url}processes/${id}`).toPromise();

      return res;
    } catch (err) {}
  }

  async getProcessValid(id) {
    // TODO change name of function not clear
    try {
      const res: any = await this.http.get(`https://sftys.cdmx.gob.mx/api/v1/processes/${id}`).toPromise();
      // const res = await this.http.get(`${this.url}processes/${id}`).toPromise();

      let timex: any = new Date(res.timestamp);

      console.log("res => ", res)

      let responsex = {
        nombre: `${res.llave.nombre} ${res.llave.primerApellido} ${res.llave.segundoApellido}`,
        fecha: res.timestamp,
        consecutivo: `${timex.getDate()}/${timex.getMonth()}/${timex.getFullYear()}/${res._id}`,
        valid: res.status != 5 ? false : true
      }

      console.log("responsex => ", responsex)

      return responsex;
    } catch (err) {}
  }

  async validateArchive(id) {
    try {
      const res: any = await this.http.get(`https://sftys.cdmx.gob.mx/api/v1/archives/validate/${id}`).toPromise();

      console.log("RES => ", res)

      return res;
    } catch (err) {
      let response: any = {};

      if (err.status == "404") {
        response.valid = false;
        response.message = "No encontró registro del documento. para más información ponte en contacto al correo electrónico: noantecedentes@cdmx.gob.mx";
      } else {
        response.valid = false;
        response.message = "Ocurrió un error al realizar la consulta. Por favor intenta más tarde.";
      }

      return response;
    }
  }

  async getTramitesPublicados () {
    // TODO implement function
    try {
      // const res = await this.http.get(`${this.url}tramites`).toPromise();
    } catch (err) {
      // console.log('err ', err);
    }
  }

  async downloadLDC(data) {
    // Donwload file directly from the backend services
    // It has to open in new tab
    try {
      // console.log("data => ", data);
      window.open(`https://sftys.cdmx.gob.mx/api/v1/generate-ldc/${data.value}?importe=$${data.importe}.00&vigencia=${data.vigencia}&codigobarras=${data.lineaCodigoBarras}`, '_blank');
    } catch (err) {
      // console.log("err => ", err);
      return { error: 1, msg: "Datos insuficientes."}
    }
  }

  async downloadVallejo(data) {
    try {
      window.open(`https://sftys.cdmx.gob.mx/api/v1/certVallejo/${data}`, '_blank');
    } catch (err) {
      return { error: 1, msg: "Datos insuficientes."}
    }
  }

  async downloadCertificate(data, llave, tramite) {
    try {
      // console.log("downloadCertificate ===> ", data);
      // console.log("llave data ==> ", llave);
      // console.log("tramite ==> ", tramite);

      let payload = {
        ciudadano: `${tramite.llave.nombre} ${tramite.llave.primerApellido} ${tramite.llave.segundoApellido}`,
        tramite: tramite.nombre,
        folio: tramite.id,
        fechaTramite: tramite.timestamp,
        fechaRenovacion: data.fecha_pago.$value
      }

      window.open(`https://sftys.cdmx.gob.mx/api/v1/certificado/${payload.folio}?ciudadano=${payload.ciudadano}&tramite=${payload.tramite}&fecha=${payload.fechaTramite}&renovacion=${payload.fechaRenovacion}`, '_blank');
    } catch (err) {
      return {};
    }
  }

  async generateLDC(id) {
    try {
      // TODO error handling
      // console.log("generateLDC => ", id);
      const res = await this.http.get(`https://sftys.cdmx.gob.mx/api/v1/ldc/${id}`).toPromise();

      return res;
    } catch (err) {
      // console.log('err', err);
    }
  }

  async getStatusLDC(id) {
    try {
      const res = await this.http.get(`https://sftys.cdmx.gob.mx/api/v1/validateLDC/${id}`).toPromise();

      return res;
    } catch (err) {

      return err;
    }
  }

  async getCitizenLDC(data) {
    try {
      // console.log("data ==> ", data);
      const res = await this.http.get(`https://sftys.cdmx.gob.mx/api/v3/resultados/findOne?filter={"where":{"linea_captura.value": "${data.respuesta.lineacaptura.$value}"}}`).toPromise();

      return res;
    } catch (err) {

      return err;
    }
  }
}
